import Cookies from "js-cookie";
import { isMobile, isEmail, isInt, isTime, isPrice } from "@/utils/validate";
import { Message, MessageBox } from "element-ui";

/**
 * 校验手机号格式
 * @param {*} rule 校验邮箱的规则名称
 * @param {*} value 需要校验的内容
 * @param {*} callback 回调返回的结果
 */
const validatorIsMobile = (rule, value, callback) => {
  if (value !== undefined && value !== null && value !== "") {
    let tips = isMobile(value);
    if (tips !== false) {
      callback(new Error(tips));
    }
  }
  callback();
};
/**
 * 校验邮箱格式
 * @param {*} rule 校验邮箱的规则名称
 * @param {*} value 需要校验的内容
 * @param {*} callback 回调返回的结果
 */
const validatorIsEmail = (rule, value, callback) => {
  if (value !== undefined && value !== null && value !== "") {
    let tips = isEmail(value);
    if (tips !== false) {
      callback(new Error(tips));
    }
  }
  callback();
};

/**
 * 校验时间格式
 * @param {*} rule 校验数字的规则名称
 * @param {*} value 需要校验的内容
 * @param {*} callback 回调返回的结果
 */
const validatorIsInt = (rule, value, callback) => {
  if (value !== undefined && value !== null && value !== "") {
    let tips = isInt(value);
    if (tips !== false) {
      callback(new Error(tips));
    }
  }
  callback();
};
/**
 * 校验正整数
 * @param {*} rule 校验时间的规则名称
 * @param {*} value 需要校验的内容
 * @param {*} callback 回调返回的结果
 */
const validatorIsTime = (rule, value, callback) => {
  if (value !== undefined && value !== null && value !== "") {
    let tips = isTime(value);
    if (tips !== false) {
      callback(new Error(tips));
    }
  }
  callback();
};
/**
 * 校验金额
 * @param {*} rule 校验金额的规则名称
 * @param {*} value 需要校验的内容
 * @param {*} callback 回调返回的结果
 */
const validatorIsPrice = (rule, value, callback) => {
  if (value !== undefined && value !== null && value !== "") {
    let tips = isPrice(value);
    if (tips !== false) {
      callback(new Error(tips));
    }
  }
  callback();
};
export default {
  validatorIsMobile,
  validatorIsEmail,
  validatorIsInt,
  validatorIsTime,
  validatorIsPrice,
  //that-调用者对象，一般是传this
  //methodsName-回车事件绑定的函数方法名
  enter(that, methodsName) {
    document.onkeydown = (e) => {
      if (e.key == "Enter" || e.key == "enter") {
        that.$options.methods[methodsName].call(that);
      }
    };
  },
  //检查是否有选中记录
  checkChoose(that, list) {
    if (list == null || list == undefined || list.length <= 0) {
      that.$message.error("请至少选择一条记录");
      return false;
    } else {
      return true;
    }
  },
  //只能选中一条记录
  checkChooseOne(that, list) {
    if (list == null || list == undefined || list.length !== 1) {
      that.$message.error("请选择且最多选择一条记录");
      return false;
    } else {
      return true;
    }
  },

  /**
   * 处理时间域参数
   * @param {*} val 参数对象
   * @param {*} areaName 时间域字段名
   * @param {*} startName 开始时间字段名
   * @param {*} endName 结束时间字段名
   */
  handleDateAreaParam(val, areaName, startName, endName) {
    if (
      val[areaName] != null &&
      val[areaName] != undefined &&
      val[areaName].length > 0
    ) {
      val[startName] = val[areaName][0];
      val[endName] = val[areaName][1];
    } else {
      val[startName] = null;
      val[endName] = null;
    }
  },

  /**
   * 判断对象数组中的某属性是否包含某个值
   * @param {*} list        对象数组
   * @param {*} fieldName   属性字段名
   * @param {*} value       需判断是否包含的值
   * @return {boolean}      true-包含；false-不包含
   */
  listCheckIncludeValue(list, fieldName, value) {
    if (list !== null && list !== undefined) {
      for (const item of list) {
        if (item[fieldName] === value) {
          return true;
        }
      }
    }
    return false;
  },
  /**
   * 在当前位置对象后插入新对象
   * @param list	目标对象集合
   * @param index	当前位置下标
   * @param newObj 初始的新对象
   */
  addCurrentObj(that, list, index, newObj) {
    if (list !== null && list !== undefined) {
      list.splice(index + 1, 0, Object.assign({}, newObj));
    }
    that.$forceUpdate();
  },
  /**
   * 在当前位置对象前插入新对象
   * @param list	目标对象集合
   * @param index	当前位置下标
   * @param newObj 初始的新对象
   */
  addPreCurrentObj(that, list, index, newObj) {
    if (list !== null && list !== undefined) {
      list.splice(index, 0, Object.assign({}, newObj));
    }
    that.$forceUpdate();
  },
  /**
   * 删除当前位置对象
   * @param list	目标对象集合
   * @param index	当前位置下标
   * @param newObj 初始的新对象
   */
  deleteCurrentObj(that, list, index, newObj) {
    if (list !== null && list !== undefined && list.length > 1) {
      list.splice(index, 1);
    } else {
      if (newObj) {
        list.splice(index, 1, Object.assign({}, newObj));
      } else {
        list.splice(index, 1);
      }
    }
    that.$forceUpdate();
  },
  //复制成功
  copySuccess(e) {
    Message({
      message: "复制成功",
      type: "success",
    });
  },
  //复制失败
  copyError(e) {
    Message({
      message: "该浏览器不支持复制功能",
      type: "error",
    });
  },
  //操作权限
  auditError(e) {
    Message({
      message: "您没有操作权限",
      type: "error",
    });
  },
  //浮窗显示完整文本
  showText(that, value) {
    that.event.target.title = value;
  },
  /**
   * 检测数组中是否包含某个值
   * @param {*} list        数组
   * @param {*} keyName     字段名  如果keyName=null说明是元素数组，否则说明是对象数组
   * @param {*} value       需检测的值
   */
  checkListContainValue(list, keyName, value) {
    if (!list || list.length === 0) {
      return false;
    }
    if (keyName && keyName !== "") {
      for (let temp of list) {
        if (temp[keyName] === value) {
          return true;
        }
      }
    } else {
      for (let temp of list) {
        if (temp === value) {
          return true;
        }
      }
    }
    return false;
  },
  /**
   * 会员等级
   */
  getMemberGrade() {
    let memberGrade = [
      {
        id: 1,
        name: "一级会员",
      },
      {
        id: 2,
        name: "二级会员",
      },
      {
        id: 3,
        name: "三级会员",
      },
      {
        id: 4,
        name: "四级会员",
      },
      {
        id: 5,
        name: "五级会员",
      },
      {
        id: 6,
        name: "六级会员",
      },
      {
        id: 7,
        name: "七级会员",
      },
      {
        id: 8,
        name: "八级会员",
      },
      {
        id: 9,
        name: "九级会员",
      },
      {
        id: 10,
        name: "十级会员",
      },
    ];
    return memberGrade;
  },

  /**
   * 所属平台
   */
  getPlatformObj() {
    let platformObj = [
      {
        value: "JD",
        name: "京东",
      },
      {
        value: "TB",
        name: "淘宝",
      },
      {
        value: "PDD",
        name: "拼多多",
      },
      {
        value: "MT",
        name: "美团",
      },
      {
        value: "ELM",
        name: "饿了么",
      },
/*      {
        value: "CYS",
        name: "萃元善",
      },*/
    ];
    return platformObj;
  },

  /**
   * 佣金类型
   */
  getCommissionTypeObj() {
    let commissionTypeObj = [
      {
        value: "JD",
        name: "京东返佣",
      },
      {
        value: "TB",
        name: "淘宝返佣",
      },
      {
        value: "PDD",
        name: "拼多多返佣",
      },
      {
        value: "MT",
        name: "美团返佣",
      },
      {
        value: "ELM",
        name: "饿了么返佣",
      },
/*      {
        value: "DY",
        name: "抖音返佣",
      },*/
      {
        value: "TG",
        name: "推广返佣",
      },
    ];
    return commissionTypeObj;
  },

  /**
   * 位置
   */
  getPositionObj() {
    let positionObj = [
      {
        id: 0,
        name: "主题模块",
      },
      {
        id: 1,
        name: "热门活动",
      },
      {
        id: 2,
        name: "高佣返推荐",
      },
      {
        id: 3,
        name: "好物推荐",
      },
      {
        id: 4,
        name: "猜你喜欢",
      },
      {
        id: 5,
        name: "首页",
      },
      {
        id: 7,
        name: "专场",
      },
      {
        id: 8,
        name: "商城",
      },
      {
        id: 9,
        name: "搜索页",
      },
      {
        id: 6,
        name: "首页轮播图",
      },
      {
        id: 10,
        name: "专场轮播图",
      },
      {
        id: 11,
        name: "二级页面",
      },
      {
        id: 12,
        name: "红包专场",
      },
    ];
    return positionObj;
  },

  /**
   * 平台类型
   */
  getTypeObj() {
    let typeObj = [
      {
        id: 0,
        name: "频道",
        children: [
          {
            id: 0,
            name: "普通频道",
          },
          {
            id: 1,
            name: "活动频道",
          },
        ],
      },
      {
        id: 1,
        name: "活动",
        children: [
          {
            id: 0,
            name: "普通活动",
          },
          {
            id: 1,
            name: "商城活动",
          },
          {
            id: 2,
            name: "营销活动",
          },
        ],
      },
      {
        id: 2,
        name: "列表",
        children: [],
      },
      {
          id: 3,
          name: "外部H5页面",
          children: [],
      },
      {
          id: 4,
          name: "外部小程序",
          children: [],
      },
      {
          id: 5,
          name: "小程序内部",
          children: [],
      },
      {
        id: 6,
        name: "红包",
        children: [],
      },
    ];
    return typeObj;
  },

  visitTypeObj() {
    let visitTypeObj = [];
    return visitTypeObj;
  },

  /**
   * 状态
   */
  getEffectiveStatusObj() {
    let effectiveStatusObj = [
      {
        id: 0,
        name: "未生效",
      },
      {
        id: 1,
        name: "生效中",
      },
      {
        id: 2,
        name: "已失效",
      },
    ];
    return effectiveStatusObj;
  },

  /**
   * 生成对应长度
   * @param {*} obj  数组
   * @param {*} checkData  数组
   */
  checkMustData(obj, checkData) {
    let string = "";
    let field = "";
    try {
      obj.forEach((element, index) => {
        checkData.forEach((item) => {
          field = item.field;
          string = element[field];
          if (string === undefined || string === null || string === "") {
            throw [index + 1, item.name];
          }
        });
      });
      return true;
    } catch (e) {
      return e;
    }
  },
  /**
   * 表格行样式控制
   * @param {*} rowIndex
   * @returns
   */
  tableRowClassName(row) {
    if (row.rowIndex % 2 != 0) {
      return "evenRow";
    }
    return "oddRow";
  },
  clearCache() {
    Cookies.remove("token"); // 放置token到Cookie
    Cookies.remove("user"); // 放置token到Cookie
    Cookies.remove("name"); // 放置token到Cookie
    Cookies.remove("merchantId"); // 放置token到Cookie

    sessionStorage.removeItem("token");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("nickName");
    sessionStorage.removeItem("registeInfo");
    sessionStorage.removeItem("id");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("merchantId");
  },
};



// WEBPACK FOOTER //
// ./src/utils/common.js